import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { LikeToneRequest } from '../api/tune/liketune/liketonerequest';
import { LikeToneResponse, LikeToneResponseDtoImpl } from '../api/tune/liketune/liketoneresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class LikeToneAPIProcessorImpl extends SixdeeCRBTAPIProcessor<LikeToneRequest, LikeToneResponse>
{
    execute(request: LikeToneRequest): void 
    {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new LikeToneResponseDtoImpl(APIFeatures.LIKE_UNLIKE_TONE, "Like Tone Success");

                this.getAPISuccess(response);
            }
        }
        catch (e) {
            this.getAPIFailure(new LikeToneResponseDtoImpl(APIFeatures.LIKE_UNLIKE_TONE, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);
 
            this.getAPIFailure(new LikeToneResponseDtoImpl(APIFeatures.LIKE_UNLIKE_TONE, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/liketoneapiprocessor.tsx